module.exports = __webpack_public_path__ + "img/Mb_Exhibition_Logo.4c6bfc57.jpg";